export default "__VITE_ASSET__BCVnk2nI__"